import * as yup from 'yup'
import { ReasonForPurchaseOtherTextValidation } from '../ReasonForPurchaseOtherText/ReasonForPurchaseOtherText.validation'
import { ReasonForPurchaseEnum } from './ReasonForPurchaseEnumeration'

export const ReasonForPurchaseValidation = yup.string()

export const ReasonForPurchaseSchema = yup.object().shape({
  reasonForPurchase: ReasonForPurchaseValidation.required(
    'Please enter a reason for cover',
  ),
  reasonForPurchase_VariantA: yup.string().optional(),
  reasonForPurchase_VariantB: yup.string().optional(),
  reasonForPurchaseOtherText: yup
    .string()
    .when('reasonForPurchase', {
      is: ReasonForPurchaseEnum.other,
      then: ReasonForPurchaseOtherTextValidation.required(
        'Please enter a reason for other',
      ),
    })
    .optional()
    .nullable(),
})

export const ReasonForPurchaseVariantASchema = yup.object().shape({
  reasonForPurchase_VariantA: ReasonForPurchaseValidation.required(
    'Please choose a reason for cover',
  ),
  reasonForPurchaseOtherText: yup
    .string()
    .when('reasonForPurchase_VariantA', {
      is: ReasonForPurchaseEnum.other,
      then: ReasonForPurchaseOtherTextValidation.required(
        'Please enter a reason for other',
      ),
    })
    .optional()
    .nullable(),
})

export const ReasonForPurchaseVariantBSchema = yup.object().shape({
  reasonForPurchase_VariantB: ReasonForPurchaseValidation.required(
    'Please choose a reason for cover',
  ),
  reasonForPurchaseOtherText: yup
    .string()
    .when('reasonForPurchase_VariantB', {
      is: ReasonForPurchaseEnum.other,
      then: ReasonForPurchaseOtherTextValidation.required(
        'Please enter a reason for other',
      ),
    })
    .optional()
    .nullable(),
})
